window.appConfig = {
    routes: {
        getServices: window.laravelConfig.routes.getServices,
        getServicesPage: window.laravelConfig.routes.getServicesPage,
        getSpecialists: window.laravelConfig.routes.getSpecialists,
        getSpecialistsPage: window.laravelConfig.routes.getSpecialistsPage,
        getFaq: window.laravelConfig.routes.getFaq,
        getReviews: window.laravelConfig.routes.getReviews,
        getServiceGroups: window.laravelConfig.routes.getServiceGroups,
        getDepartment: window.laravelConfig.routes.getDepartment,
        getDoctorStores: window.laravelConfig.routes.getDoctorStores,

        recordGetProfessions: window.laravelConfig.routes.recordGetProfessions,
        recordGetDoctors: window.laravelConfig.routes.recordGetDoctors,
        recordGetServices: window.laravelConfig.routes.recordGetServices,
        recordGetSchedule: window.laravelConfig.routes.recordGetSchedule,
        recordAdd: window.laravelConfig.routes.recordAdd,
        reviewSend: window.laravelConfig.routes.reviewSend,
        getArticles: window.laravelConfig.routes.getArticles,
        sendContract: window.laravelConfig.routes.sendContract,
        sendProgram: window.laravelConfig.routes.sendProgram,
        getPrograms: window.laravelConfig.routes.getPrograms,
    },
    csrfToken: window.laravelConfig.csrfToken,
    specialistsPlug: window.laravelConfig.specialistsPlug,
    baseUrl: window.laravelConfig.baseUrl,

    reviewsPage: window.laravelConfig.reviewsPage || { type: 'home', userId: 0, limit: 3 },
};